import React from 'react';
import selfPortrait from '../assets/selfpotrait.png';
import artTwo from '../assets/halloween.jpg';
import './VanGoghFeature.css';


const VanGoghFeature = () => {
  return (
    <div className="van-gogh-feature">
      {/* Navigation Back to Home */}

      <div className="w-full h-screen flex bg-[#f4f3ef]" style={{ height: '100vh', overflow: 'hidden' }}>
        {/* LEFT PANEL */}
        <div className="w-1/2 px-16 py-14 overflow-y-auto" style={{ height: '100vh', overflowY: 'auto' }}>
          {/* Tag */}
          <div className="inline-block bg-black text-white text-xs tracking-widest px-3 py-1 mb-6">
            About Me
          </div>

          {/* Headline - Centered at top */}
          <h1 className="text-[72px] leading-[0.95] font-serif text-[#5C8F97] mb-6 text-center">
            Samuel <br /> Tinevra
          </h1>

          {/* Subheading - Centered below headline */}
          <p className="text-sm text-gray-700 max-w-2xl mx-auto leading-relaxed mb-12 text-center">
           I’m a software engineer and a self-taught artist for over a decade.

My foundation is technical. My perspective is artistic.

With the rise of AI, I now combine both worlds engineering structured systems while directing bold visual outcomes. This intersection allows me to move fluidly between concept and execution, strategy and aesthetics.

I’m currently open to art direction projects where clarity, innovation, and creative control matter.

Design with discipline.
Art with intention.
          </p>

          {/* Editorial Grid */}
          <div className="mt-16 grid grid-cols-2 gap-10">
            {/* Column 1 */}
            <div>
              <h3 className="text-[#5C8F97] font-semibold mb-2">
                1. Self-Portrait with Felt Hat
              </h3>
              <p className="text-xs text-gray-600 mb-4">
                December 1886 - January 1887
              </p>
              <p className="text-sm text-gray-700 leading-relaxed mb-6">
                Vincent van Gogh painted at least 35 self-portraits during his lifetime...
              </p>
              <img
                src={selfPortrait}                 
                alt="Self Portrait"
                className="w-full object-cover mb-6"
              />
              <h3 className="text-[#5C8F97] font-semibold mb-2">
                2. Self-Portrait
              </h3>
              <p className="text-xs text-gray-600 mb-4">
                March-June 1887
              </p>
              <p className="text-sm text-gray-700 leading-relaxed">
                That this neo-Impressionist study was made on card suggests...
              </p>
                <p className="text-sm text-gray-700 leading-relaxed">
                That this neo-Impressionist study was made on card suggests...
              </p>
              
            </div>

            {/* Column 2 */}
            <div>
              <img
            src={artTwo}
                alt="Self Portrait 2"
                className="w-full object-cover mb-6"
              />
              <h3 className="text-[#5C8F97] font-semibold mb-2">
                3. Self-Portrait with Grey Felt Hat
              </h3>
              <p className="text-xs text-gray-600 mb-4">
                Spring 1887
              </p>
              <p className="text-sm text-gray-700 leading-relaxed">
                The fragmented experiments of the previous portrait coalesced...
              </p>
            </div>
          </div>
        </div>

        {/* RIGHT PANEL IMAGE */}
        <div className="w-1/2 h-full flex items-center justify-center bg-[#f4f3ef]">
          <img
            src={artTwo}
            alt="Van Gogh self portrait"
            className="max-w-full max-h-full object-contain"
          />
        </div>
      </div>
    </div>
  );
};

export default VanGoghFeature;